/* eslint-disable */
/** 
 * This file contains language specific message functions for tree-shaking. 
 * 
 *! WARNING: Only import messages from this file if you want to manually
 *! optimize your bundle. Else, import from the `messages.js` file. 
 * 
 * Your bundler will (in the future) automatically replace the index function 
 * with a language specific message function in the build step. 
 */


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__add = () => `Ajouter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__back = () => `Retour`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__back_home = () => `Retour à la page d'accueil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__back_overview = () => `Retour à l'aperçu`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__back_to_search = () => `Retour à la recherche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__close_panel = () => `Réduire le panneau`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__delete = () => `Supprimer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__edit = () => `Modifier`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__modify = () => `Modifier`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__open_panel = () => `Ouvrir le panneau`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__print = () => `Imprimer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__retry = () => `Réessayer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__save = () => `Enregistrer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__sign_in = () => `Connexion`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__sign_up = () => `Inscription`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__validate = () => `Confirmer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__article_button = () => `Lire l'article`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__badge_text = () => `Le Mag`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__button_label = () => `Voyager`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__first_line = () => `Nos destinations incontournables et toutes nos inspirations de voyage sont dans`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__generic_button = () => `Découvrir`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__generic_subtitle = () => `Découvrez nos conseils de voyage et laissez-vous guider avec Le Mag`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__generic_title = () => `Besoin d'inspiration ?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__second_line = () => `le Magazine ViaMichelin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const address__summary__error__detail = () => `Nous n'arrivons pas à obtenir l'information.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const address__summary__error__title = () => `Lieu introuvable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alert_itinerary__closed_roads__cta = () => `Déviation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alerts_traffic_panel__close_button__label = () => `Fermer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alerts_traffic_panel__no_events__label = () => `Il n’y a actuellement pas d’alertes dans la zone choisie.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alerts_traffic_panel__select_location__label = () => `Pour afficher les alertes, saisissez un lieu dans le champ de recherche.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__add__itinerary = () => `Ajouter cet itinéraire à mes favoris`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__badge_car = () => `Voiture`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__badge_caravan = () => `Caravane`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__badge_electricCar = () => `Voiture électrique`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__badge_motorcycle = () => `Moto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__delete_favorite_ariaLabel = () => `Effacer l'itinéraire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__favorite__routes = () => `Itinéraires favoris`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__favorite_limit_reached = () => `Vous avez atteint la limite de sauvegarde des itinéraires en favoris.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__favorite_limit_reached__cta = () => `Voir les favoris`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__find_favorites_routes = () => `Retrouver mes itinéraires favoris`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__iti_deleted__success = () => `Itinéraire supprimé des favoris`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__iti_save_error = () => `Cet itinéraire n'a pas pu être ajouté aux favoris.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__iti_save_error__cta = () => `Réessayer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__itinerary__saved = () => `Itinéraire sauvegardé`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__itinerary_saved = () => `Itinéraire ajouté aux favoris`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__no_saved_itineraries = () => `Aucun itinéraire mis en favoris`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__save_favorite_route = () => `Sauvegardez vos itinéraires favoris`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__see = () => `Voir les favoris`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__see_favorite_route = () => `Voir l'itinéraire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__table_head_actions = () => `Actions (Effacer ou voir l'itinéraire)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__table_head_iti_details = () => `Détails de l'itinéraire (départ, arrivée, étapes)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__via = () => `Via`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const calendar__arrival__placeholder = () => `Arrivée`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const calendar__arrival__title = () => `Sélectionnez une date d'arrivée`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const calendar__cancel = () => `Effacer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const calendar__validate = () => `Confirmer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__arrival_placeholder = () => `Date d'arrivée`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__close_aria_label = () => `Effacer les dates sélectionnées`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__departure_placeholder = () => `Départ`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__night_count_placeholder__one = () => `nuit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__night_count_placeholder__other = () => `nuits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__trigger_aria_label = () => `Sélectionnez les dates de début et de fin à l'aide du widget calendrier.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__back_home = () => `retourner à la page d’accueil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__or = () => `ou`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__text_end = () => `si vous ne trouvez pas ce que vous cherchez.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__text_start = () => `Vous pouvez`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__title = () => `Cette page a été supprimée ou modifiée`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__500__text_end = () => `pour obtenir de l’aide.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__500__text_start = () => `Notre équipe s’active pour résoudre le problème. Vous pouvez réessayer plus tard ou`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__500__title = () => `Cette page n’a pas pu être chargée`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__contact_us = () => `nous contacter`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ev_spots__many = (params) => `${params.count} places`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ev_spots__one = () => `1 place`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const favoriteItineraries__deleteError = () => `Cet itinéraire n’a pas pu être supprimé des favoris`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer__faq_title = () => `Questions fréquentes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer__magazine_button = () => `Parcourir le Magazine ViaMichelin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer__newsletter_button = () => `S'inscrire à notre Newsletter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__B10 = () => `Gazole Premium`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__B7 = () => `Gazole`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__CNG = () => `Méthane`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__E10 = () => `SP 95 - E10`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__E5 = () => `SP 95`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__E5_98 = () => `SP 98`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__E85 = () => `Éthanol`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__H2 = () => `H2`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__LPG = () => `GPL`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const highways = () => `Autoroutes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const input__clear = () => `Effacer la saisie`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__ad__loading = (params) => `Votre itinéraire dans ${params.count} s`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__add_step = () => `Ajouter une étape`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__compute = () => `Rechercher un itinéraire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__current_location = () => `Votre position actuelle`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__edit = () => `Modifier`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__invert = () => `Inverser`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__max_steps_reached = () => `Nombre maximum d'étapes atteint`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_badge__edit = () => `Modifier votre véhicule`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_badge__register = () => `Ajouter votre véhicule`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_badge__user = () => `Mon véhicule`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__bifuel = () => `Bi-carburant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__cng = () => `CNG`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__diesel = () => `Diesel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__electric = () => `Électrique`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__ethanol = () => `Éthanol`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__gasoline = () => `Essence`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__hybrid = () => `Hybride`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__hydrogen = () => `Hydrogène`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__lpg = () => `LPG`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__city = () => `Citadine`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__compact = () => `Compacte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__saloon = () => `Berline`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__sports = () => `Sportive`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__suv = () => `SUV`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__caravan_toggle = () => `Vous roulez avec une caravane`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__caravan_toggle_helper_text = () => `Adapte les données de coût, durée de trajet et consommation mais pas l’itinéraire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__cars__error = () => `Les véhicules n'ont pas pu être affichés.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__cars__retry = () => `Réessayer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_border_crossing = () => `Pas de sortie du territoire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_ferry = () => `Pas de traversées maritimes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_low_emission_zone = () => `Éviter les zones à faibles émissions`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_motorway = () => `Éviter les voies rapides`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_toll = () => `Éviter les péages`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_vignette = () => `Pas d'achat de vignette`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__none = () => `Aucune`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency = () => `Devise`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__chf = () => `CHF - Franc suisse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__czk = () => `Kč - Couronne tchèque`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__dkk = () => `kr - Couronne danoise`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__eur = () => `€ - Euro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__gbp = () => `£ - Livre sterling`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__hrk = () => `kn - Kuna croate`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__huf = () => `Ft - Forint hongrois`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__jpy = () => `¥ - Yen japonais`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__nok = () => `kr - Couronne norvégienne`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__pln = () => `zł - Zloty polonais`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__sek = () => `kr - Couronne suédoise`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__uah = () => `₴ - Hryvnia ukrainienne`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__usd = () => `$ - Dollar américain`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__distance_unit = () => `Unité de distance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__ev_toggle = () => `Vous roulez en véhicule électrique`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__fuel__price = () => `Prix au litre`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__kwh__price = () => `Prix du kWh`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__bike = () => `À vélo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__car = () => `En voiture`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__car_ev_limit = () => `Recharger lorsque vous atteignez...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__car_ev_limit_warning_message = () => `Des variables (température, vent, nombre de passagers...) peuvent affecter l’autonomie de votre véhicule électrique. Pensez à garder un peu de marge !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__motorcycle = () => `À moto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__walk = () => `À pied`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__title = () => `Paramètres de votre trajet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__traffic_toggle = () => `Éviter les embouteillages`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__travel_mode = () => `Votre moyen de transport`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__trip_constraint = () => `Vos préférences sur la route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__units__imperial = () => `Miles`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__units__metric = () => `Kilomètres`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__recompute = () => `Rechercher un itinéraire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__summary__traffic_avoided_badge = () => `Trafic évité`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const kleber__restStop__description = () => `recommande cette aire pour les familles`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const kleber__village__description = () => `recommande ce village étape pour les familles`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_add_car = () => `Ajoutez votre véhicule pour des estimations de coûts plus précises`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_create = () => `Créez votre compte en quelques clics`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_create_account = () => `Créer un compte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_ideas = () => `Faites le plein d’idées : découvrez nos destinations phares et nos road trips grâce à`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_more = () => `En savoir plus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_newsletter = () => `notre Newsletter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_save_pref = () => `Enregistrez vos préférences de trajets`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_signin = () => `S’inscrire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__cost_cta_label = () => `Calculer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__cost_notification = () => `Entrez un départ et une arrivée pour voir le détail du coût de l’itinéraire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__cost_title = () => `Le coût détaillé de vos trajets`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__headline_title = () => `Sur ViaMichelin, retrouvez ...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__magazine_cta_label = () => `Visiter le Mag`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__magazine_title = () => `Des contenus pour  vous inspirer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__pois_hrt = () => `Voir les points d’intérêts`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__selection_cta_label = () => `Découvrir la sélection`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__selection_title = () => `Toute la sélection Michelin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__zois_cta_label = () => `Découvrir`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__zois_notification = () => `Entrez un départ et une arrivée pour retrouver les escales suggérées`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__zois_title = () => `Des idées d’escales sur votre route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__header = () => `Apparence de votre carte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__historic__image_alt = () => `Calque historique`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__historic__label = () => `Historique`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__hybrid__image_alt = () => `Calque hybride`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__hybrid__label = () => `Hybride`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__michelin__imagex_alt = () => `Calque Michelin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__michelin__label = () => `Michelin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__scenic__imagex_alt = () => `Calque belles routes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__scenic__label = () => `Belles routes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__confidentiality_policy = () => `Politique de confidentialité`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__contact = () => `Contactez-nous`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__cookies = () => `Cookies`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__credits = () => `Crédits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__legal_notice = () => `Notices légales`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__term_of_use = () => `Conditions d'utilisation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const location_control__error = () => `Nous n'arrivons pas à déterminer votre position exacte.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const location_control__tooltip__header = () => `Votre localisation est désactivée`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const location_control__tooltip__text = () => `Modifiez les paramètres de votre navigateur pour autoriser l'accès à votre position.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_callback__close_button = () => `Fermer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_callback__failure = () => `Échec lors de la connexion`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_callback__success = () => `Connexion réussie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__access_profile = () => `Accéder à mon profil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__compass = () => `Boussole`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__location = () => `Localisation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__login_profile = () => `Se connecter à mon profil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__profile = () => `Profil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__settings = () => `Paramètres`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__zoom_in = () => `Zoom avant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__zoom_out = () => `Zoom arrière`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__partner_hotel = () => `Hôtels`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__partner_hotel__long_label = () => `Trouver un hébergement`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__go_to_traffic_info_page__label = () => `Alertes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__low_emission_zone__label = () => `Zones à faibles émissions`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info__label = () => `Afficher`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_busy__label = () => `Dense`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_closed_lane__label = () => `Route fermée`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_display_alerts__label = () => `Afficher les alertes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_fluid__label = () => `Fluide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_heavy__label = () => `Saturée`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const modal__bookTheFork = () => `Widget de réservation TheFork`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const modal__close = () => `Fermer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const modal__locale_switch_title = () => `ViaMichelin existe en plusieurs langues`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const other_roads = () => `Autres voies`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__first = () => `Première page`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__last = () => `Dernière page`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__nav = () => `Pagination Navigation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__next = () => `Page suivante`


/**
 * @param {{ page: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__page = (params) => `Page ${params.page}`


/**
 * @param {{ page: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__page_active = (params) => `Page ${params.page}, page actuelle`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__prev = () => `Page précédente`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__end_of_results = () => `Fin des résultats`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__next = () => `Suivant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__previous = () => `Précédent`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poiCard__seeDetails = () => `Voir le détail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__activities = () => `Activités`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__add_to_itinerary = () => `Étape`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__book = () => `Réserver`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__cancel = () => `Annuler`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__details = () => `Détails`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__itinerary = () => `Itinéraire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__actions_book = () => `Réserver`


/**
 * @param {{ average: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__average_price = (params) => `Environ ${params.average}`


/**
 * @param {{ price: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__book_min_price = (params) => `Réserver à partir de ${params.price}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__aria_label = () => `Carrousel d'image pour`


/**
 * @param {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__list_aria_label = (params) => `image ${params.current} sur ${params.total}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__next_button = () => `Voir le contenu suivant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__prev_button = () => `Voir le contenu précédent`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__charging_power__many = (params) => `Max ${params.count} kW`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__charging_power__one = (params) => `${params.count} kW`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__count_more_than_3_connectors = (params) => `+ ${params.count} plus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__image_alt = () => `Image du lieu`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__michelin = () => `Guide Michelin`


/**
 * @param {{ min: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__min_price = (params) => `À partir de ${params.min}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__non_availability = () => `Complet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__price_tag_average = () => `Environ`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__price_unavailable = () => `Prix indisponible`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__bad = () => `Mauvais`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__disappointing = () => `Décevant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__exceptional = () => `Exceptionnel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__fabulous = () => `Fabuleux`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__good = () => `Bon`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__mediocre = () => `Médiocre`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__passable = () => `Passable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__pleasant = () => `Agréable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__quite_mediocre = () => `Assez médiocre`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__superb = () => `Superbe`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__very_good = () => `Très bien`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__well = () => `Bien`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review_count = (params) => `${params.count} avis`


/**
 * @param {{ date: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__updated = (params) => `Mis à jour le ${params.date}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__accommodation = () => `Hébergements`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__ev_service = () => `Recharges auto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__gas_station = () => `Stations service`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__parking = () => `Parkings`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__rest_stop = () => `Aires de repos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__restaurant = () => `Restaurants`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__tourism = () => `Tourisme`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__header = () => `Points d'intérêt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__not_available = () => `Les points d’intérêt ne peuvent pas être affichés sur cette page.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__select_all = () => `Tout afficher`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__unselect_all = () => `Tout masquer`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availabilities__many__overnight_stay = (params) => `Disponibilité pour ${params.count} nuits avec`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availabilities__one__overnight_stay = () => `Disponibilité pour 1 nuit avec`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability = () => `Dates de votre séjour`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__error = () => `Les informations n'ont pas pu être affichées.`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__view__many__other = (params) => `${params.count} autres`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__view__one__other = () => `1 autre`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__view_more__on_partner_website = () => `Aller sur Booking.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__with = () => `Disponibilité avec`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability_offer = (params) => `Offre ${params.count}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__back_to_list = () => `Retour à la liste`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__carousel__close_button = () => `Fermer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__description = () => `À propos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__accommodation_subtype__bb = () => `Chambre d'hôtes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__accommodation_subtype__camping = () => `Camping`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__accommodation_subtype__hotel = () => `Hôtel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__accommodation_subtype__residence = () => `Résidence`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__rest_stop__rest = () => `Aire de repos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__rest_stop__service = () => `Aire de service`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__image_alt = () => `Image du lieu`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__location = () => `Localisation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__michelin_opinion = () => `L'avis du Guide Michelin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__michelin_opinion__tourism = () => `L’avis du Guide Michelin Voyage & Cultures`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__practical_info = () => `Informations pratiques`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label = () => `Découvrir sur GetYourGuide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tours_not_found = () => `Les activités n’ont pas pu être affichées.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tours_not_found_with_region = () => `Nous n'avons pas trouvé d’activités à proximité mais il y en a beaucoup d’autres dans cette région.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tours_not_found_without_region = () => `Nous n'avons pas trouvé d’activités à proximité mais il y en a beaucoup d’autres dans cette région.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tours_not_found_without_region_label = () => `Découvrir sur GetYourGuide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__not_found_image_alt = () => `Bib cherchant à l'horizon`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__title = () => `Vous aimerez peut-être…`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__see_more = () => `Voir plus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__see_on_map = () => `Voir sur la carte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__strong_points = () => `Ses points forts`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__back = () => `Fermer les filtres avancés`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__detailed_view__label = () => `Afficher les prix, le nombre d’étoiles...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__fetch_error = () => `Les informations n'ont pas pu être affichées.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__no_selected_categories = () => `Activez une catégorie ci-dessus pour`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__only__michelin = () => `Uniquement la sélection Michelin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__select_to_filter = () => `afficher les filtres correspondants.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__selected_items__all = () => `Toutes`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__selected_items__many = (params) => `${params.count} sélectionnés`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__selected_items__none = () => `Aucun filtre`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__selected_items__one = () => `1 sélectionné`


/**
 * @param {{ hours: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__last_update = (params) => `${params.hours}h max`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_count = (params) => `${params.count} et plus`


/**
 * @param {{ power: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_power = (params) => `Minimum ${params.power}kW`


/**
 * @param {{ amount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_price__eur = (params) => `${params.amount} € et plus`


/**
 * @param {{ amount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_price__usd = (params) => `$${params.amount} et plus`


/**
 * @param {{ minRate: NonNullable<unknown>, maxRate: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_rate = (params) => `Minimum ${params.minRate}/${params.maxRate}`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_stars__one = (params) => `${params.count} étoile et plus`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_stars__other = (params) => `${params.count} étoiles et plus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__none = () => `Aucun filtre`


/**
 * @param {{ amount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price__eur = (params) => `${params.amount} €`


/**
 * @param {{ amount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price__usd = (params) => `$${params.amount}`


/**
 * @param {{ minAmount: NonNullable<unknown>, maxAmount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price_range__eur = (params) => `${params.minAmount} € à ${params.maxAmount} €`


/**
 * @param {{ minAmount: NonNullable<unknown>, maxAmount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price_range__usd = (params) => `$${params.minAmount} à $${params.maxAmount}`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__stars = (params) => `${params.count} étoiles`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__aria_label__filter_button = () => `Ouvrir les filtres`


/**
 * @param {{ numberOfFilters: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__aria_label__filter_button_filtered__many = (params) => `${params.numberOfFilters} filtres activés`


/**
 * @param {{ numberOfFilters: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__aria_label__filter_button_filtered__one = (params) => `${params.numberOfFilters} filtre activé`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__errors__no_category = () => `Pour afficher des points d'intérêt (hôtels, restaurants...), vous devez sélectionner au moins une catégorie.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__errors__no_result = () => `Nous n'avons pas trouvé ce que vous cherchez autour de cet emplacement. Réessayez en élargissant votre zone de recherche.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__filters__toggle_label = () => `Filtrer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_marker__pin = () => `Pin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_search_category__aria_label = () => `Recherche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__close = () => `Fermer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__login = () => `Se connecter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__logout = () => `Se déconnecter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__favorites__title = () => `Itinéraires favoris`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__banner = () => `Ces données sont liées à vote compte Michelin.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__form__email = () => `Adresse e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__form__name = () => `Nom`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__form__password = () => `Mot de passe`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__modify = () => `Modifier sur michelin.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__title = () => `Informations du compte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__settings__banner = () => `Vous pourrez aussi modifier ces paramètres lors de la recherche de votre itinéraire.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__settings__title = () => `Paramètres de trajet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__settings__vehicle = () => `Votre véhicule`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const refresh_control__label = () => `Actualiser`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__construction_year = () => `Année`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__fuel = () => `Carburant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__info_box__text = () => `Nous mettons régulièrement à jour notre base de données. Si votre véhicule n’y figure pas, choisissez un modèle similaire ou un de nos véhicules par défaut.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__info_box__title = () => `Vous ne trouvez pas votre véhicule ?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__motor = () => `Motorisation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__account_subtitle = () => `Pour enregistrer votre véhicule, vous devez avoir un compte Michelin.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__account_title = () => `Avez-vous un compte ?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__fill_to_save = () => `Pour enregistrer, vous devez remplir tous les champs.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__register_error = () => `Il y a eu une erreur lors de l’enregistrement. Pouvez-vous réessayer ?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__register_success = () => `Votre véhicule a été enregistré.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__search_placeholder = () => `Marque et modèle`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__vehicle = () => `Véhicule`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__dogArea = () => `Espace canin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__nursery = () => `Nurserie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__picnicTable = () => `Tables de pique-nique`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__playGround = () => `Aire de jeux`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__restaurant = () => `Restaurant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__shop = () => `Boutique`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restaurantMichelin_greenStarLabel = () => `Gastronomie durable`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const road_typology = () => `Typologie de route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roadsheet__scenic_roads = () => `Belles routes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__arrival = () => `Arrivée`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__alternative = () => `Alternatif`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__discovery = () => `Découverte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__ecological = () => `Écologique`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__economic = () => `Économique`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__quickest = () => `Rapide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__shortest = () => `Court`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__departure = () => `Départ`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__details = () => `Continuer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__error = () => `Les informations n'ont pas pu être affichées.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__final_charge = () => `Arrivée à`


/**
 * @param {{ tollCost: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__included_costs = (params) => `dont ${params.tollCost} de péages`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__itineraries__many = (params) => `${params.count} itinéraires possibles`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__itineraries__one = (params) => `${params.count} itinéraire conseillé`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__not_found = () => `Nous n’avons trouvé aucun itinéraire. Pouvez-vous modifier votre recherche ?`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__recharge = (params) => `${params.count} recharge(s)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__restrictions_tip__selected = () => `Restriction(s) sur ce trajet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__restrictions_tip__unselected = () => `Restriction(s) à prévoir sur ce trajet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_cost = () => `Coût`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_distance = () => `Distance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_duration = () => `Durée`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_electricity_consumption = () => `Consommation d’électricité`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_emission = () => `Émissions CO2`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector_error_message = () => `Essayez de modifier votre recherche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector_no_address = () => `Lieux inconnus.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector_no_road = () => `Aucun itinéraire.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__alternative = () => `marqueur sur l'itinéraire alternatif`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__default = () => `marqueur sur l'itinéraire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__discovery = () => `marqueur sur l'itinéraire découverte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__ecological = () => `marqueur sur l'itinéraire écologique`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__economic = () => `marqueur sur l'itinéraire économique`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__quickest = () => `marqueur sur l'itinéraire le plus rapide`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__shortest = () => `marqueur sur l'itinéraire le plus court`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__step = () => `étape`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs = () => `Coût`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__costs_details = () => `Détails des coûts`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__electricity = () => `Électricité`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__estimated_for = () => `Coût estimé pour`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__fuel = () => `Carburant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__tolls = () => `Péages`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__tolls_list = () => `Liste des péages`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__total_cost = () => `Coût total du trajet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__vignette = () => `Vignette`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note = () => `Note de frais`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__allowance = () => `Indemnité forfaitaire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__arrival = () => `Arrivée`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__back = () => `Retour à la note de frais`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__costs = () => `Dépenses`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__date = () => `Date`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__departure = () => `Départ`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__distance = () => `Distance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__additional_data = () => `Informations complémentaires`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__additional_data_placeholder = () => `Toutes autres informations utiles.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__allowance = () => `Au forfait`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__allowance_input = () => `Indemnité`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__compute_method = () => `Méthode de calcul`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__electricity = () => `Coût de l'électricité (€/kWh)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__fuel = () => `Coût du carburant (€/litre)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__identity = () => `Identité du demandeur`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__identity_placeholder = () => `Prénom et Nom`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__include = () => `Inclure les éléments suivants`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__legal_info = () => `Informations légales`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__real = () => `Au réel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__title = () => `Modifier la note de frais`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__travel_date = () => `Date du déplacement`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__electricity = () => `Électricité`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__fuel = () => `Carburant`


/**
 * @param {{ date: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__generated_on = (params) => `Générée sur ViaMichelin le ${params.date}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__identity = () => `Demandeur`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__notes = () => `Description`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__tolls = () => `Péages`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__total = () => `Total`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__travel = () => `Détails`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__vignette = () => `Vignettes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__instructions = () => `Instructions`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__instructions__error = () => `Les instructions de navigation n’ont pas pu être affichées.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way = () => `Sur le trajet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__detour = () => `Sur le trajet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__infos = () => `Correspond à la distance entre votre trajet et les points d'intérêt proposés.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__scope = () => `Périmètre de recherche`


/**
 * @param {{ value: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__up_to = (params) => `Jusqu'à ${params.value} km`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__recommendations = () => `À découvrir`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__blablacar__cta = () => `Covoiturez`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__blablacar__description = () => `Montant moyen constaté`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__blablacar__subtitle = () => `avec`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__blablacar__title = () => `Economisez 60€`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__button_label = () => `Coûts détaillés`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__ev_charging = () => `Énergie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__fuel = () => `Carburant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__title = () => `Coût de ce trajet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__tolls = () => `Péages`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__on_the_road__title = () => `Sur le trajet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__rest_stop__button_label = () => `Idées d’escales`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__button_label = () => `Feuille de route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__emissions = () => `Émissions`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__ev_charging = () => `Recharges`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__highway = () => `Voies rapides`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__title = () => `Feuille de route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_zoi_hotel__cta_label = () => `Voir les hébergements`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_zoi_hotel__title = () => `Hébergements à l'arrivée`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__cta_label = () => `Conduisez malin`


/**
 * @param {{ device: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__cta_url = (params) => `https://www.blablacar.fr/offer-seats?comuto_cmkt=FR_VIAMICHELIN_ACQ_DRVR_BONUSCOVOITURAGE_COUTDETAILLE${params.device}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__description = () => `Devenez conducteur BlaBlaCar et économisez 60€ sur votre prochain trajet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__legal_notice = () => `*Montant moyen perçu par un conducteur BlaBlaCar en 2022 pour un trajet aller-retour avec 3 passagers. Plus d'informations sur blablacar.fr`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__title = () => `Covoiturez et économisez`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__cta_label = () => `Conduisez malin`


/**
 * @param {{ departure: NonNullable<unknown>, arrival: NonNullable<unknown>, device: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__cta_url = (params) => `https://www.blablacar.fr/offer-seats?comuto_cmkt=FR_VIAMICHELIN_ACQ_DRVR_BONUSCOVOITURAGE_BOXFDR${params.device}`


/**
 * @param {{ cost: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__description = (params) => `Devenez conducteur BlaBlaCar et économisez 60€ sur votre prochain trajet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__legal_notice = () => `*Montant moyen, plus d'informations sur blablacar.fr`


/**
 * @param {{ departure: NonNullable<unknown>, arrival: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__title = (params) => `Covoiturez et économisez !`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search__input__aria_label = () => `On va où ?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__button__aria_label = () => `Itinéraire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__button__text = () => `Itinéraire`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__messages__empty = () => `Aucun résultat trouvé`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__messages__error = () => `Il y a eu une erreur.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__messages__image_alt = () => `Bib observant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__results__aria_label = () => `Résultats de la recherche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const settings__close = () => `Fermer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const sf_logout__close_button = () => `Fermer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const sf_logout__loading = () => `Déconnexion en cours...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const sf_logout__logged_out = () => `Déconnexion réussie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const soon = () => `Bientôt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_deviation__cta = () => `Ignorer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__car_accident = () => `Accident`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__car_dangerous = () => `Route fermée`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__car_incident = () => `Incident`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__construction_cone = () => `Travaux`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__lane_closed = () => `Rétrécissement`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__weather_hail = () => `Météo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_info_settings__header = () => `ÉTAT DU TRAFIC`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view_more__go_to_partner_website = () => `Aller sur Booking.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view_more__no_room = () => `Pas de disponibilité`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view_more__on = () => `Nous avons trouvé peu d'hébergements qui correspondent à votre recherche. Pour plus de choix, rendez-vous sur`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view_more__on_partner_website = () => `Booking.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__ev_only = () => `Uniquement avec stations de recharge`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__search_range = () => `Périmètre de recherche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__search_range__text = () => `Correspond à la distance entre votre trajet et les points d’intérêt proposés.`


/**
 * @param {{ value: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__search_range__value = (params) => `Jusqu’à ${params.value} km`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__pois__see_all = () => `Voir plus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__pois_subtitle = () => `Nos recommandations d’hébergements, de restaurants...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__pois_title = () => `Points d'intérêt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__title = () => `Idées d’escales`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__arrival__available_accommodation = () => `Des hébergements sont disponibles dans votre zone d’arrivée.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__arrival__see_accommodation_zone = () => `Voir sur la carte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__error = () => `Les points d’intérêt n’ont pas pu être affichés.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__image_alt = () => `Zone d'intérêt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__see_on_map = () => `Voir sur la carte`
